export const digitsOnly = (value) =>
  String(value ?? '').replace(/\D/g, '');

export const decimalOnly = (value, maxDecimalPlaces = 2) => {
  const sanitized = String(value ?? '').replace(/[^\d.]/g, '');
  const decimalIndex = sanitized.indexOf('.');

  if (decimalIndex === -1) {
    return sanitized;
  }

  const whole = sanitized.slice(0, decimalIndex);
  const fraction = sanitized
    .slice(decimalIndex + 1)
    .replace(/\./g, '')
    .slice(0, maxDecimalPlaces);

  return `${whole}.${fraction}`;
};
